import {APIURLLEGALES} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {
  async fetchEstadosFacturas() {
    const url=APIURLLEGALES + "/liquidacion/EstadosFactura"
    const response = apiClient.get(url)
    const data = await response
    return data;
  }
}

export default ApiServiceAdapter;